'use client'

import { useDynamicI18n } from '@/hooks/use-dynamic-i18n'

type TTemplateTitleProps = {
  title: string
}

/**
 * Client component to render translated template title
 * @param title - Template title or AI-generated name
 * @returns Translated template title
 */
export function TemplateTitle({ title }: TTemplateTitleProps) {
  const { dt } = useDynamicI18n()

  return <h1 className="text-3xl font-bold text-white">{dt(title)}</h1>
}
